import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { makeSelectLocale } from 'store/language/selectors';

const mapStateToProps = createSelector(makeSelectLocale(), (locale) => ({ locale }));

const useLocale = () => useSelector(mapStateToProps).locale;

export default useLocale;
